import { PartGrade, ServiceProposalPartAction } from "@repo/common"

/**
 * Sorts part actions according to the specified priority:
 * 1. Part actions with included products (products or productChoices) first
 * 2. Part actions with comments second
 * 3. Parts with lower grades (worse condition) prioritized last
 */
export function sortPartActions(
  partActions: ServiceProposalPartAction[],
): ServiceProposalPartAction[] {
  return [...partActions].sort((a, b) => {
    // Priority 1: Actions with included products (products or productChoices)
    const aHasProducts = a.products.length > 0 || a.productChoices.length > 0
    const bHasProducts = b.products.length > 0 || b.productChoices.length > 0

    if (aHasProducts && !bHasProducts) return -1
    if (!aHasProducts && bHasProducts) return 1

    // Priority 2: Actions with comments
    const aHasComment = a.comment !== null && a.comment.trim() !== ""
    const bHasComment = b.comment !== null && b.comment.trim() !== ""

    if (aHasComment && !bHasComment) return -1
    if (!aHasComment && bHasComment) return 1

    // Priority 3: Lower grades first (worse condition = lower number = higher
    // priority), ungraded last
    const gradeDiff =
      (a.partGrade ?? PartGrade.TEN + 1) - (b.partGrade ?? PartGrade.TEN + 1)
    if (gradeDiff !== 0) return gradeDiff

    // Fallback: Sort by part name for consistent ordering
    return a.partName.localeCompare(b.partName)
  })
}
